import { TColor, ITypography } from "../../../types";

export type ProgressBarLabel = "none" | "right" | "bottom" | "top" | "tooltip-bottom" | "tooltip-top";

export type ProgressBarProps = {
    /**
     * Current progress value. The expected value should be in the range 0 - 100. Values outside of it will default to the minimum or maximum value. To define a different range, use `minValue` and `maxValue` props.
     */
    value: number;
    /**
     * Minimum expected value
     * @default 0
     */
    minValue?: number;
    /**
     * Maxmimum expected value
     * @default 100
     */
    maxValue?: number;
    /**
     * Define how label will be displayed.
     * @default "none"
     */
    label?: ProgressBarLabel;
    /**
     * Define the displayable text for label. You can directly define the text or take the provided prop values and use them to to customize the label.
     * @default {value.toFixed()}%
     */
    text?: string | ((value: number, minValue: number, maxValue: number) => string);
    /**
     * Define the width of the progress bar (including the label).
     * @default "320px"
     */
    width?: React.CSSProperties["width"];
    /**
     * Define the progress color in case you need a different styling.
     * @default "primary-800"
     */
    progressColor?: TColor;
    /**
     * Define the progress background color in case you need a different styling.
     * @default "primary-50"
     */
    progressBackgroundColor?: TColor;
    /**
     * Define the label color in case you need a different styling.
     * @default "primary-1200"
     */
    labelColor?: TColor;
    /**
     * Define the label size in case you need a different font size.
     * @default "label-small-medium"
     */
    labelSize?: keyof ITypography;
};
